module.exports = __webpack_public_path__ + "media/images/element/27-b6865df5f06eb1ff5e7bb6fa92c794e6.svg";